import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getGroups = store => store[NAME].groups;
export const getDateFormat = store => store[NAME].dateFormat;
